import React from 'react';
interface TabItem<T extends string> {
  id: T;
  label: string;
}
interface TabsProps<T extends string> {
  label: string;
  tabs: TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
}
export function Tabs<T extends string>({
  label,
  tabs,
  active,
  onChange
}: TabsProps<T>) {
  return <div role="tablist" aria-label={label} className="flex gap-6 border-b border-sf-border px-4" data-id="element-909" data-mp="1gyobcvx16xws">
      {tabs.map(tab => {
      const isActive = tab.id === active;
      return <button key={tab.id} type="button" role="tab" aria-selected={isActive} onClick={() => onChange(tab.id)} className={`-mb-px h-10 border-b-2 text-sm transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sf-blue ${isActive ? 'border-sf-blue font-semibold text-sf-text' : 'border-transparent text-sf-weak hover:border-sf-border-strong hover:text-sf-text'}`} data-id="element-910" data-mp="oasglwr0vg2n">
            {tab.label}
          </button>;
    })}
    </div>;
}